<template>
	<div class="My_pop _popRight" id="POP-track" style="display: block;"><!-- POP -->
		<div class="pop_right" style="right: 0px;"><!-- pop_right -->
			
			<ul class="pop_right_header2">
				<li><h2>我的足迹</h2></li>
				<li><btn class="pop_right_close2" name="pop-close" @click="closeFloat"></btn></li>
			</ul>
			
			<div class="MyTrack_tool">
				<div class="L">
					
					<div class=" cei-select " name="cei-select" style="width:160px">
						<i class="cei-icon icon-arrdown"></i>
						<div class="inpout" @click="seltimeVisible=true">{{timetypetxt}}</div>
						<ul v-show="seltimeVisible" style="display: block;">
						  <li @click="selTimeType('')">一个月内</li>
						  <li @click="selTimeType('2')">三个月内</li>
						  <li @click="selTimeType('3')">半年内</li>
						  <li @click="selTimeType('4')">一年内</li>
						</ul>
					</div>
					
				</div>
				<div  class="R">
					<div class="ml_1 info_txt" >全部<font class="red">{{totalResultCount}}</font>条浏览记录</div>
					<!-- <div class="ml_1" ><btn class="btn-clear">全部清除</btn></div> -->
				</div>
			</div>
			
			
			
			<div class="pop_right_main"><!-- main -->
			
						<div  class="thematic_list  "><!-- thematic_list -->
							<section v-for="(item,index) in resultDataList">
								<dl>
									<dt>
										<div class="T-date"><d1>{{item.time.substring(8,10)}}</d1><d2>{{item.time.substring(0,7)}}</d2></div>
										<T-vline></T-vline>
									</dt>
									<dd>
										<ul  class="list4b"  >
											<li v-for="(aitem,aindex) in item.data">
												<router-link :to="{ name: 'detail', params: { id: aitem.id }}" target="_blank">{{aitem.title}}</router-link>
											</li>
										</ul>
									</dd>
								</dl>
							</section>
							
						</div><!-- /thematic_list -->
	
	<!--				<div class="m_b1"></div>-->
										
										
			</div><!-- /main -->
			
			<div class="pop_right_footer2">
					<!-- <ul class="pages">
						<li class="p- p-pre p-grey"><a href="" class="cei-icon icon-pre"></a></li>
						<li class="p- p-curr"><a href="">1</a></li>
						<li class="p- "><a href="">2</a></li>
						<li class="p-"><a href="">3</a></li>
						<li class="p-"><a href="">4</a></li>
						<li class="p-"><a href="">5</a></li>
						<li class="p-more "><a href="" class="cei-icon icon-more"></a></li>
						<li class="p-"><a href="">10</a></li>
						<li class="p- p-next "><a href="" class="cei-icon icon-next"></a></li>
					</ul> -->
					<el-row class="pagediv">
						<el-pagination @size-change="changePageSize" @current-change="changeSearchPage" :current-page="pageNum"
							 layout="prev, pager, next"
							:total="totalResultCount">
						</el-pagination>
					</el-row>
			</div>
			
		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /POP -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				seltimeVisible:false,
				timetype:'',
				timetypetxt:'一个月内',
				pageNum: 1,
				pageSize: 20,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			this.getHistoryfnc();
			this.$track([
				['pagetype','我的足迹']
			]);
		},
		methods: {
			getHistoryfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserRecord',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
							type:this.timetype,
						},
					})
					.then(function(response) {
						var responsedata = response.data.data.data.data;
						var tempdata=[];
						if(responsedata){
							for(var i=0;i<responsedata.length;i++){
								if(tempdata.length>0&&responsedata[i].browsetime.substring(0,10)==tempdata[tempdata.length-1].time){
									tempdata[tempdata.length-1].data.push(responsedata[i]);
								}
								else {
									tempdata.push({
										time:responsedata[i].browsetime.substring(0,10),
										data:[responsedata[i]]
									})
								}
							}
						}
						_this.resultDataList = tempdata;
						_this.totalResultCount = parseInt(response.data.data.data.totalcount?response.data.data.data.totalcount:'0');
						_this.loadingMask = false;
						_this.$emit('senddata',_this.totalResultCount);
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getHistoryfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.getHistoryfnc();
			},
			selTimeType:function(type){
				if(type=='2'){
					this.timetype='2';
					this.timetypetxt='三个月内';
					this.seltimeVisible=false;
				}
				else if (type=='3'){
					this.timetype='3';
					this.timetypetxt='半年内';
					this.seltimeVisible=false;
				}
				else if (type=='4'){
					this.timetype='4';
					this.timetypetxt='半年内';
					this.seltimeVisible=false;
				}
				else{
					this.timetype='';
					this.timetypetxt='一个月内';
					this.seltimeVisible=false;
				}
				this.pageNum=1;
				this.pageSize=15
				this.getHistoryfnc();
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
		},
	}
</script>

<style>

</style>
